import { Action, createReducer, on } from "@ngrx/store";
import { IChatUserInfosState, INIT_CHAT_AVATARS_STATE } from "./chatUserInfo.state";
import * as ChatUserInfoActions from './chatUserInfo.actions';

const _chatUserInfosReducer = createReducer(

    INIT_CHAT_AVATARS_STATE,

    on(
        ChatUserInfoActions.updateChatUserInfoData,
        (state, action) => {
            return {
                ...state,
                [action.userId]: action.chatUserInfoData
            }
        }
    ),

    on(
        ChatUserInfoActions.clearChatUserInfoData,
        (state, action) => {
            let newState = {...state};
            delete newState[action.userId];
            return newState;
        }
    )
);

export function chatUserInfosReducer(state: IChatUserInfosState, action: Action) {
    return _chatUserInfosReducer(state, action);
}
